// ABOUTME: Globe icon marking server-translated text (WA-762 activity localization)
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const TranslateIcon = ({ className = "", size = 12, color = "#9CA3AF" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle
      cx="6"
      cy="6"
      r="5.125"
      stroke={color}
      strokeWidth="0.875"
    />
    <ellipse
      cx="6"
      cy="6"
      rx="2.25"
      ry="5.125"
      stroke={color}
      strokeWidth="0.875"
    />
    <path
      d="M1.1 4.35H10.9M1.1 7.65H10.9"
      stroke={color}
      strokeWidth="0.875"
      strokeLinecap="round"
    />
  </svg>
)
